import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Layout
import Header from "../layout/header2";
import Footer from "../layout/footer";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import servicesPic1 from "../../images/services/pic1.jpg";
 
class ServiceC extends Component{
	
	render(){
		return (
			<>
				
				<Header />
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Cirugia Laparoscopica</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><a href="index.html"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Inicio</a></li>
											<li className="breadcrumb-item active" aria-current="page">Cirugia Laparoscopica</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										<img src={servicesPic1} className="rounded" alt=""/>
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15">¿Qué es la cirugía laparoscópica? </h2>
											<p className="mb-0">La cirugía laparoscópica o “mínimamente invasiva” es una técnica especializada para realizar cirugía. Anteriormente, esta técnica se usaba por lo general para cirugía ginecológica y de vesícula biliar. Durante los últimos 10 años, el uso de esta técnica se ha ampliado e incluye la cirugía intestinal. En la cirugía tradicional “abierta”, el cirujano usa una sola incisión para entrar al abdomen. La cirugía laparoscópica usa varias incisiones de 0.5 a 1 cm. Cada incisión se denomina “puerto”. En cada puerto se inserta un instrumento tubular conocido como trocar. Durante el procedimiento, a través de los trocares se pasan instrumentos especializados y una cámara especial llamada laparoscopio. Al iniciar el procedimiento, el abdomen se infla con el gas llamado dióxido de carbono para proporcionar al cirujano un espacio de trabajo y visibilidad. El laparoscopio transmite imágenes de la cavidad abdominal a los monitores de video de alta resolución del quirófano. Durante la operación, el cirujano observa las imágenes detalladas del abdomen en el monitor. El sistema permite que el cirujano realice las mismas operaciones que la cirugía tradicional pero con incisiones más pequeñas. En ciertos casos, el cirujano puede elegir usar un tipo de puerto especial que es lo suficientemente amplio como para insertar una mano. Cuando se usa un puerto para mano, la técnica quirúrgica se llama laparoscopia "asistida con la mano". La incisión necesaria para un puerto para mano es más grande que las demás incisiones de laparoscopia, pero es normalmente más pequeña que la incisión para cirugía tradicional.</p>
										</div>
 
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h4 className="title mb-10">Preguntas al respecto</h4>
 										</div>
										<Accordion defaultActiveKey="0" className="accordion ttr-accordion1">
											<Accordion.Item eventKey="0">
												<Accordion.Header>¿Cuáles son las ventajas de la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">En comparación con la cirugía tradicional abierta, los pacientes sienten menos dolor, tienen un período de recuperación más breve y hay menos cicatrización con la cirugía laparoscópica.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="1">
												<Accordion.Header>¿Qué tipo de operaciones puede realizarse con la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">La mayoría de las cirugías intestinales puede realizarse con la técnica laparoscópica. Éstas incluyen la cirugía para la enfermedad de Crohn, colitis ulcerosa, diverticulitis, cáncer, prolapso rectal y estreñimiento grave. Anteriormente, había preocupación por la seguridad de la cirugía laparoscópica en las operaciones de cáncer. En la actualidad, varios estudios en los que participaron cientos de pacientes han demostrado que la cirugía laparoscópica es segura para ciertos cánceres colorrectales.</p>
												</Accordion.Body>
											</Accordion.Item>
											<Accordion.Item eventKey="2">
												<Accordion.Header>¿Qué tan segura es la cirugía laparoscópica?</Accordion.Header>
												<Accordion.Body>
													<p className="mb-0">La cirugía laparoscópica es tan segura como la cirugía tradicional abierta. Al iniciar una operación laparoscópica, se inserta el laparoscopio a través de una incisión pequeña y cercana al ombligo. El cirujano inspecciona primero el abdomen para determinar si es seguro realizar una cirugía laparoscópica. Si hay una gran inflamación, o si el cirujano encuentra otros factores que impiden ver claramente las estructuras, puede tener que hacer una incisión más grande para terminar la operación de manera segura. Toda cirugía intestinal implica un cierto riesgo, tal como complicaciones relacionadas con la anestesia y hemorragias o complicaciones de infección. El riesgo de toda operación lo determina en parte la naturaleza de la operación específica. La salud general de la persona y otros problemas médicos también son factores que afectan el riesgo de cualquier operación. Usted debe hablar con el cirujano acerca de su riesgo en particular para alguna operación.</p>
												</Accordion.Body>
											</Accordion.Item>
											 
										</Accordion>
									</div>
								</div>
								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
										<div className="widget">
											<ul className="service-menu">
											<li ><Link to="/service_ct"><span>Colecistectomía Laparoscópica</span><i className="fa fa-angle-right"></i></Link></li>
												<li className="active"><Link to="/service_erge"><span>Funduplicatura</span><i className="fa fa-angle-right"></i></Link></li> 
											</ul>
										</div>
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
				<Footer />
				
			</>
		);
	}
}

export default ServiceC;